<script setup>
import { ref } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import CampaignButtons from "./CampaignButtons.vue";
import Create from "./Create.vue";
import ListPagination from "./ListPagination.vue";
import fetchData from "@/utils/fetchData";
import { count } from "@/utils/format";

const campaigns = ref([]);
const listPaginationRef = ref(null);

const updateList = async (page) => {
  const result = await fetchData("getCampaignList", {
    page,
  });
  campaigns.value = result.campaigns;
};

const addLink = async ({ id, text }) => {
  await fetchData("setCampaignLink", {
    id,
    link: text,
  });
  updateList(1);
};

const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
};

updateList(1);
</script>

<template>
  <section class="container mx-auto px-4 py-3">
    <div class="card p-5 sm:p-6">
      <h2 class="section-title">Campaigns</h2>
      <p class="card-note mb-4">
        A link for each place you share MakeMeA, counting the clicks it brings.
      </p>
      <CampaignButtons @reload="updateList(1)" />
      <div class="-mx-5 overflow-x-auto px-5 sm:-mx-6 sm:px-6">
        <table class="w-full min-w-[640px]">
          <thead>
            <tr>
              <th class="th">Name</th>
              <th class="th">Link to share</th>
              <th class="th">Where it's shared</th>
              <th class="th text-right">Clicks</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="campaign in campaigns" :key="campaign._id">
              <td class="td font-medium">{{ campaign.name }}</td>
              <td class="td">
                <button
                  type="button"
                  class="inline-flex items-center gap-2 rounded-lg px-1 -mx-1 font-mono text-xs text-secondary hover:text-primary dark:text-night-muted dark:hover:text-white"
                  title="Copy the link"
                  @click="copyToClipboard(campaign.url)"
                >
                  {{ campaign.url }}
                  <FontAwesomeIcon icon="copy" />
                </button>
              </td>
              <td class="td">
                <a
                  v-if="campaign.link"
                  :href="campaign.link"
                  class="break-all text-accent underline hover:no-underline"
                  target="_blank"
                  rel="noopener"
                >
                  {{ campaign.link }}
                </a>
                <Create
                  v-else
                  placeholder="Paste where it's shared"
                  button="Save"
                  :id="campaign._id"
                  @create="addLink($event)"
                />
              </td>
              <td class="td text-right font-semibold">
                {{ count(campaign.views || 0) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ListPagination
        ref="listPaginationRef"
        paginationUrl="getCampaignPagination"
        noun="campaigns"
        @currentPageUpdate="updateList($event)"
      />
    </div>
  </section>
</template>
